
import { Task } from "@/models/tasks/task";
import { AuthService, TaskService } from "@/services";
import Vue from "vue";
import AppPendingTasks from "../../components/tasks/PendingTasks.vue";
import AppMissingModule from "@/components/common/MissingModuleModal.vue";
import { TranslateResult } from "vue-i18n";
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import { DashboardTasksData } from "@/utils/dashboard/dashboard-tasks-data";

export default Vue.extend({
	data(){
		return {
			tasks: [] as Task[]
		};
	},
	props: {
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		}
	},
	computed: {
		isAllowed():boolean{
			return AuthService.hasModule(76);
		},
		title():TranslateResult{
			return this.$ct("pending-tasks");
		}
	},
	methods: {
		async fetch(){
			let data = this.item.Data as DashboardTasksData;
			this.tasks = await TaskService.getWidgetTasks(data.filters);
		}
	},
	mounted(){
		this.fetch();
	},
	components: {
		AppPendingTasks,
		AppMissingModule
	},
	i18nEx: {
		componentPrefix: "views.HomeRoute"
	}
});
